import React, { useState, useEffect } from 'react';
import apiClient from '../../api/axiosConfig';
import { API_ENDPOINTS } from '../../constants';
import { useToast } from '../../contexts/ToastContext';
import MetaTagsUpdater from '../../components/MetaTagsUpdater'; // Import MetaTagsUpdater

function PrivacyPolicy() {
  const { addToast } = useToast();
  const [policy, setPolicy] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPolicy = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await apiClient.get(API_ENDPOINTS.PRIVACY_POLICY);
        if (response.data && response.data.success && response.data.data) {
          setPolicy(response.data.data);
        } else {
          setPolicy(null);
          setError(response.data.message || 'No privacy policy data found in response.');
          addToast(response.data.message || 'No privacy policy data found.', 'info');
        }
      } catch (err) {
        console.error('Error fetching Privacy Policy:', err);
        setError(err.response?.data?.message || 'Failed to load privacy policy. Please try again later.');
        addToast(err.response?.data?.message || 'Failed to load privacy policy.', 'error');
      } finally {
        setLoading(false);
      }
    };

    fetchPolicy();
  }, [addToast]);

  if (loading) {
    return (
      <div className="pt-20 text-center text-text-white">
        <MetaTagsUpdater pageKey="PrivacyPolicy" />
        Loading privacy policy...
      </div>
    );
  }

  if (error) {
    return (
      <div className="pt-20 text-center text-red-500">
        <MetaTagsUpdater pageKey="PrivacyPolicy" />
        {error}
      </div>
    );
  }

  if (!policy || !policy.content) {
    return (
      <div className="pt-20 text-center text-text-gray">
        <MetaTagsUpdater pageKey="PrivacyPolicy" />
        No privacy policy found.
      </div>
    );
  }

  return (
    <div className="pt-20">
      <MetaTagsUpdater pageKey="PrivacyPolicy" />
      <div className="max-w-6xl mx-auto px-5 py-8">
        <h1 className="text-4xl font-bold text-center text-text-white mb-16 relative after:content-[''] after:absolute after:bottom-0 after:left-1/2 after:-translate-x-1/2 after:w-20 after:h-1 after:bg-accent-red after:rounded-sm after:bottom-[-15px]">
          Privacy Policy
        </h1>
        <div className="bg-bg-light p-8 rounded-lg shadow-md text-text-gray rich-text-content">
          <div dangerouslySetInnerHTML={{ __html: policy.content }} />
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;